/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Test_LeaveInputs */

const th_meeting_test_leave = /** @type {(inputs: Meeting_Test_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ออกจากห้อง`)
};

const en_meeting_test_leave = /** @type {(inputs: Meeting_Test_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leave room`)
};

const ja_meeting_test_leave = /** @type {(inputs: Meeting_Test_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`退室`)
};

const zh_meeting_test_leave = /** @type {(inputs: Meeting_Test_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`离开房间`)
};

const es_meeting_test_leave = /** @type {(inputs: Meeting_Test_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salir de la sala`)
};

const pt_meeting_test_leave = /** @type {(inputs: Meeting_Test_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sair da sala`)
};

const id_meeting_test_leave = /** @type {(inputs: Meeting_Test_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tinggalkan ruang`)
};

const fr_meeting_test_leave = /** @type {(inputs: Meeting_Test_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quitter le salon`)
};

const tl_meeting_test_leave = /** @type {(inputs: Meeting_Test_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umalis sa silid`)
};

const vi_meeting_test_leave = /** @type {(inputs: Meeting_Test_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rời phòng`)
};

const ko_meeting_test_leave = /** @type {(inputs: Meeting_Test_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`방 나가기`)
};

const de_meeting_test_leave = /** @type {(inputs: Meeting_Test_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raum verlassen`)
};

const ru_meeting_test_leave = /** @type {(inputs: Meeting_Test_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выйти из комнаты`)
};

const tr_meeting_test_leave = /** @type {(inputs: Meeting_Test_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odadan ayrıl`)
};

const it_meeting_test_leave = /** @type {(inputs: Meeting_Test_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esci dalla stanza`)
};

const pl_meeting_test_leave = /** @type {(inputs: Meeting_Test_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opuść pokój`)
};

const uk_meeting_test_leave = /** @type {(inputs: Meeting_Test_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вийти з кімнати`)
};

const hi_meeting_test_leave = /** @type {(inputs: Meeting_Test_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कक्ष छोड़ें`)
};

const ar_meeting_test_leave = /** @type {(inputs: Meeting_Test_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مغادرة الغرفة`)
};

const ms_meeting_test_leave = /** @type {(inputs: Meeting_Test_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tinggalkan bilik`)
};

const bn_meeting_test_leave = /** @type {(inputs: Meeting_Test_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কক্ষ ছাড়ুন`)
};

const zh_tw2_meeting_test_leave = /** @type {(inputs: Meeting_Test_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`離開房間`)
};

const zh_hk2_meeting_test_leave = /** @type {(inputs: Meeting_Test_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`離開房間`)
};

const ur_meeting_test_leave = /** @type {(inputs: Meeting_Test_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کمرہ چھوڑیں`)
};

const fa_meeting_test_leave = /** @type {(inputs: Meeting_Test_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ترک اتاق`)
};

const sw_meeting_test_leave = /** @type {(inputs: Meeting_Test_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toka chumbani`)
};

const nl_meeting_test_leave = /** @type {(inputs: Meeting_Test_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruimte verlaten`)
};

/**
* | output |
* | --- |
* | "Leave room" |
*
* @param {Meeting_Test_LeaveInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const meeting_test_leave = /** @type {((inputs?: Meeting_Test_LeaveInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Test_LeaveInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_meeting_test_leave(inputs)
	if (locale === "ja") return ja_meeting_test_leave(inputs)
	if (locale === "zh") return zh_meeting_test_leave(inputs)
	if (locale === "es") return es_meeting_test_leave(inputs)
	if (locale === "pt") return pt_meeting_test_leave(inputs)
	if (locale === "id") return id_meeting_test_leave(inputs)
	if (locale === "fr") return fr_meeting_test_leave(inputs)
	if (locale === "tl") return tl_meeting_test_leave(inputs)
	if (locale === "vi") return vi_meeting_test_leave(inputs)
	if (locale === "ko") return ko_meeting_test_leave(inputs)
	if (locale === "de") return de_meeting_test_leave(inputs)
	if (locale === "ru") return ru_meeting_test_leave(inputs)
	if (locale === "tr") return tr_meeting_test_leave(inputs)
	if (locale === "it") return it_meeting_test_leave(inputs)
	if (locale === "pl") return pl_meeting_test_leave(inputs)
	if (locale === "uk") return uk_meeting_test_leave(inputs)
	if (locale === "hi") return hi_meeting_test_leave(inputs)
	if (locale === "ar") return ar_meeting_test_leave(inputs)
	if (locale === "ms") return ms_meeting_test_leave(inputs)
	if (locale === "bn") return bn_meeting_test_leave(inputs)
	if (locale === "zh-TW") return zh_tw2_meeting_test_leave(inputs)
	if (locale === "zh-HK") return zh_hk2_meeting_test_leave(inputs)
	if (locale === "ur") return ur_meeting_test_leave(inputs)
	if (locale === "fa") return fa_meeting_test_leave(inputs)
	if (locale === "sw") return sw_meeting_test_leave(inputs)
	if (locale === "nl") return nl_meeting_test_leave(inputs)
	return en_meeting_test_leave(inputs)
});